module.exports = __webpack_public_path__ + "static/media/white-configure-data-symbols-icon.fd9a90e8.svg";